import { render } from "./SystemSettingPage.vue?vue&type=template&id=21b613ee"
import script from "./SystemSettingPage.vue?vue&type=script&lang=js"
export * from "./SystemSettingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__